<script>
    import anchored from '../components/private/anchored';
    import $locale from '../prototype/locale';
    import $markdown from '../prototype/markdown';

    import icon_back from '!!raw-loader!../icon/round/material/back.svg';
    import icon_next from '!!raw-loader!../icon/round/material/next.svg';
    import icon_done from '!!raw-loader!../icon/round/close.svg';

    export let persistent;


    /**
     * A tooltip is an enhanced version of the HTML tooltip as produced by the `title` attribute. A tooltip consists
     * of text in Markdown format that communicates information about an element's purpose when a user hovers over an
     * element, or takes some action that causes the `$tooltip` method to be fired manually.
     *
     * Tooltips also support `back`, `next`, and `done` buttons that are displayed if a handler for the corresponding
     * event is present.
     */
    export default {
        name: 'tooltip',
        mixins: [anchored],

        props: {
            /**
             * The message displayed in the tooltip, in Markdown format.
             */
            msg: String,
            /**
             * A color name [positive, negative, buy, sell, etc.]
             */
            tone: String,
            /**
             * Appearance modifier. `pill` is supported.
             */
            appearance: String,
            /**
             * Action event handlers.
             */
            onback: Function,
            onnext: Function,
            ondone: Function
        },

        computed: {
            offset() {
                return 6;
            },
            transformOrigin() {
                return (this.origin.left || '-6px') + ' ' + (this.origin.top || '-6px');
            },
            dir() {
                return this.$root.__app?.direction;
            },
            _class() {
                return {
                    _v: this.visible,
                    _ttn: this.nested,
                    ['_p'+this.actual]: true,
                    ['_a'+this.align]: true,
                    ['_e'+this.appearance]: !!this.appearance
                };
            }
        },

        watch: {
            anchor: {
                handler(to, from) {
                    if (to) {
                        to._tt = this;
                    }
                    if (from) {
                        from._tt = undefined;
                    }
                },
                immediate: true
            }
        },

        render(h) {
            const bg = this.tone ? 'bg-' + this.tone : void 0;
            return h('div', {
                'staticClass': '_mdls _tt _con',
                'class': this._class,
                'style': 'transform-origin:' + this.transformOrigin,
                'attrs': {
                    dir: this.dir
                }
            }, [
                h('div', {
                    'staticClass': '_mdlsa',
                    'class': bg,
                    'style': this.origin
                }),
                h('div', {
                    'staticClass': '_mdlsdef _ttdef',
                    'class': bg
                }, [
                    h('div', {
                        'staticClass': '_ttar article',
                        'attrs': {
                            dir: 'auto'
                        },
                        'domProps': {
                            innerHTML: $markdown.toHTML(this.msg)
                        }
                    }),
                    this.onback || this.onnext || this.ondone ? h('div', {
                        'staticClass': '_ttbt'
                    }, [
                        this.ondone ? h('ib-button', {
                            'staticClass': 'link start-md',
                            'domProps': {
                                innerHTML: $locale.data.Done + '&ensp;' + icon_done
                            },
                            'on': {
                                click: this.ondone
                            }
                        }) : void 0,
                        this.onnext ? h('ib-button', {
                            'staticClass': 'link start-md',
                            'domProps': {
                                innerHTML: $locale.data.Next + '&ensp;' + icon_next
                            },
                            'on': {
                                click: this.onnext
                            }
                        }) : void 0,
                        this.onback ? h('ib-button', {
                            'staticClass': 'link end-md',
                            'domProps': {
                                innerHTML: icon_back + '&ensp;' + $locale.data.Back
                            },
                            'on': {
                                click: this.onback
                            }
                        }) : void 0
                    ]) : void 0
                ])
            ]);
        },

        methods: {
            onOpen() {
                if (this.persistent) {
                    persistent = this;
                }
            },

            onClose() {
                if (this.persistent) {
                    persistent = null;
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../less/globals.less";

    ._tt {
        background-color: @bg-tooltip;
        z-index: @z-tooltip;
        &._epill > ._ttdef {
            border-radius: 999em;
        }
    }
    ._ttdef {
        display: flex;
        flex-direction: column;
        padding: 8px;
        overflow: hidden;
        .font-size(@fs8);
        .line-height-auto(@fs8);
        color: @fg-tooltip;
        border-radius: 2px;
        pointer-events: none;
        will-change: transform;

        a, button {
            pointer-events: all;
        }
        & when (iscolor(@fg-tooltip-accent)) {
            a, button {
                color: @fg-tooltip-accent;
            }
        }
    }
    ._ttar {
        max-width: 360px;
        > :first-child {
            margin-top: 0 !important;
        }
        > :last-child {
            margin-bottom: 0 !important;
        }
    }
    ._ttbt {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        margin-top: 8px;
        > ._btn {
            color: inherit;
            font: inherit;
            font-weight: 600;
        }
    }
</style>
